import styled from 'styled-components'
import { Alert } from 'reactstrap'

export const FixedAlert = styled(Alert)`
    position: fixed!important;
    top: 0;
    width: 100%;
    z-index: 100;
`